import React from "react";
import { Cog, Shield, MapPin } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function WhyTheSharkBite() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "Powerful Equipment",
    description: "We operate the heavy-duty Kubota SVL973 Track Loader with a forestry mulcher, capable of handling dense brush, trees, and large properties with unmatched efficiency.",
    icon: <Cog className="size-10 text-primary" />
  }, {
    title: "Fully Insured",
    description: "Peace of mind is part of the package. We are a fully insured, professional team committed to safety and protecting your property throughout the clearing process.",
    icon: <Shield className="size-10 text-primary" />
  }, {
    title: "Local Reliability",
    description: "Deeply rooted in East Texas, we understand the local landscape and the specific needs of ranchers and landowners. We show up on time and get the job done right.",
    icon: <MapPin className="size-10 text-primary" />
  }];
  return <section id="why-the-shark-bite" ref={ref} className={cn("dark bg-card text-foreground py-20 relative overflow-hidden transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute top-0 left-0 w-full h-1 bg-primary/20" />
      <div className="absolute bottom-0 right-0 w-full h-1 bg-primary/20" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold tracking-tight mb-4 uppercase">
            Why The <span className="text-primary">Shark Bite?</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Rugged equipment, professional service, and a commitment to clearing
            East Texas land the right way.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => <div key={i} data-index={i} className={cn("transition-all duration-700 delay-[var(--delay)]", isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0")} style={{
          "--delay": `${i * 150}ms`
        } as React.CSSProperties}>
              <Card className="h-full bg-background/50 border-border/50 hover:border-primary/50 transition-colors duration-300 shadow-lg">
                <CardHeader className="pb-2">
                  <div className="mb-4 inline-flex items-center justify-center size-16 rounded-lg bg-primary/10 border border-primary/20">
                    {feature.icon}
                  </div>
                  <CardTitle className="text-xl font-bold uppercase tracking-wide">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}